var React = require('react');
var ReactNative = require('react-native');

var dismissKeyboard = require('react-native-dismiss-keyboard');

var Icon = require('./wrappers/ReUpIcon');

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var QRCodeView = require('./QRCodeView.js');
var ReUpButton = require('./ReUpButton.js');
var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpField = require('./ReUpField');
var NetworkManager = require('./NetworkManager.js');
var CheckMarkView = require('./CheckMarkView');
var FadingView = require('./FadingView');
var {PhysScene, PhysObject} = require('./PhysScene');
var PaymentMethodChooserView = require('./PaymentMethodChooserView.js');


var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKSpinner
} = MK;

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  StyleSheet,
  Vibration,
  Platform,
  Keyboard,
  TouchableWithoutFeedback,
} = ReactNative;

var PREVIOUS_TIP_AMOUNT = "PREVIOUS_TIP_AMOUNT";
var PREVIOUS_TIP_TYPE = "PREVIOUS_TIP_TYPE";

function getBase64Data(data)
{
  var dataJsonString = JSON.stringify(data);
  var dataBase64 = btoa(dataJsonString);

  return dataBase64;
}

var UseCredit = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null
    }
  },

  getInitialState : function()
  {
    var otherText = this.props.appManager.getLocalizationManager().localizedStringForKey("OTHER_BUTTON")
    var tipChoiceTitles = ["0%","15%","20%",otherText];
    var tipChoiceValues = [0,15,20];
    var tipEnabled = true;
    var tipChoiceType = 0;
    if( this.props.appManager != null )
    {
      var featureData = this.props.appManager.getFeatureForName("UseCredit");
      if( featureData && typeof featureData !== 'undefined' )
      {
        tipEnabled = (typeof featureData.data.shouldUseTip === 'undefined') || featureData.data.shouldUseTip;
        if( typeof featureData.data.tipValues !== 'undefined' )
        {
          tipChoiceType = typeof featureData.data.tipType !== 'undefined' ? featureData.data.tipType : 0;
          tipChoiceTitles = [];
          tipChoiceValues = [];
          for( var i = 0; i < featureData.data.tipValues.length; i++ )
          {
            var thisValue = featureData.data.tipValues[i];
            tipChoiceValues.push(parseInt(thisValue));
            if( tipChoiceType == 0 )
            {
              tipChoiceTitles.push(thisValue + "%");
            }
            else
            {
              tipChoiceTitles.push(this.props.appManager.getLocalizationManager().localizedDollars(thisValue));
            }
          }
          tipChoiceTitles.push(this.props.appManager.getLocalizationManager().localizedStringForKey("OTHER_BUTTON"));
        }
      }
      var locManager = this.props.appManager.getLocalizationManager();
      if( typeof locManager.getConstants()["TIP_CHOICES"] !== 'undefined' )
      {
        tipChoiceValues = locManager.getConstants()["TIP_CHOICES"];
        tipChoiceTitles = [];
        for( var i = 0; i < tipChoiceValues.length; i++ )
        {
          tipChoiceTitles.push(tipChoiceValues[i] + "%");
        }
        if( tipChoiceValues.length > 0 ) tipChoiceTitles.push(locManager.localizedStringForKey("OTHER_BUTTON"));
      }
    }

    var appManager = this.props.appManager;
    var hasSelectedTip = false;
    if( typeof appManager._tipAmount !== 'undefined' && typeof appManager._tipType !== 'undefined' )
    {
      this._tipAmount = appManager._tipAmount;
      this._tipType = appManager._tipType;

      var newTipChoiceTitles = [];
      for( var i = 0; i < tipChoiceTitles.length-1; i++ )
      {
        newTipChoiceTitles.push(tipChoiceTitles[i]);
      }
      if( this._tipType == "P" ) newTipChoiceTitles.push(this._tipAmount + "%");
      else if( this._tipType == "D" ) newTipChoiceTitles.push(locManager.localizedDollars(this._tipAmount));

      hasSelectedTip = true;
      tipChoiceTitles = newTipChoiceTitles;
    }

    var addCreditFeature = this.props.appManager.getFeatureForName("AddCredit");
    var isLivePay = appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.PayMode] == 1;

    var shouldShowLoadCredit = !isLivePay && typeof addCreditFeature !== 'undefined' && addCreditFeature != null && !this.props.appActions._navigator.featureIsInStack(addCreditFeature);
    var shouldShowPaymentMethods = isLivePay;
    var shouldShowBalance = !isLivePay || (this.props.appManager.currentUser()[ModelConstants.Credits] > 0);
    var shouldShowTip = !isLivePay || (this.props.appManager.currentUser()[ModelConstants.Credits] > 0);

    return {
      layout : this.props.initialLayout,
      tipChoiceTitles : tipChoiceTitles,
      tipChoiceValues : tipChoiceValues,
      tipChoiceType : tipChoiceType,
      tipEnabled : tipEnabled,
      shouldShowLoadCredit : shouldShowLoadCredit,
      shouldShowPaymentMethods : shouldShowPaymentMethods,
      shouldShowBalance : shouldShowBalance,
      shouldShowTip : shouldShowTip,
      hasSelectedTip : hasSelectedTip,
      renderAlternative : false,
      renderAlternativeView : null,
    }
  },

  componentDidMount : function()
  {
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;

    var thisThing = this;
    appManager.getVariable(PREVIOUS_TIP_AMOUNT, (varAmount)=>
    {
      if( varAmount != null )
      {
        appManager.getVariable(PREVIOUS_TIP_TYPE, (varType)=>
        {
          if( varType != null )
          {
            if( varAmount != thisThing._tipAmount || varType != thisThing._tipType)
            {
              setTimeout(()=>thisThing.setTip(varAmount, varType), 100);
            }
          }
        })
      }
    })

    if( appManager.isLoggedIn() )
    {
      this._creditUsed = appManager.currentUser()[ModelConstants.TotalCreditUsedAtScanner];
      this._pointsAdded = appManager.currentUser()[ModelConstants.TotalPointsAddedAtScanner];
      this._points = appManager.currentUser()[ModelConstants.Points];
      this._credit = appManager.currentUser()[ModelConstants.Credits];
      this._hash = appManager.currentUser()[ModelConstants.Hash];
    }

    this.setTip();
    this.queuePoll();
    //
    // NetworkManager.update(appManager, ['Users'], function()
    // {
    //   // success
    // }, function(result)
    // {
    //   appActions.checkErrorCodeAndReturnIfHandled(result.code)
    // }, function(data)
    // {
    //   appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
    // });
  },

  componentWillUnmount : function()
  {
    if( this._pollTimeout != null ) clearTimeout(this._pollTimeout);
  },

  _pollTimeout : null,
  _isFirstPoll : true,
  queuePoll : function()
  {
    var appManager = this.props.appManager;
    var thisThing = this;
    this._pollTimeout = setTimeout(()=>
    {
      if( appManager.isLoggedIn() )
      {
        NetworkManager.updateFeature( appManager, "User", (user)=>
        {
          if( typeof user !== 'undefined' && user != null && typeof user[ModelConstants.Hash] !== 'undefined' )
          {
            var newHash = user[ModelConstants.Hash];
            var newCreditUsed = user[ModelConstants.TotalCreditUsedAtScanner];
            var newPointsAdded = user[ModelConstants.TotalPointsAddedAtScanner];
            var newCredit = user[ModelConstants.Credits];
            var newPoints = user[ModelConstants.Points];
            if( newCredit != thisThing._credit || newPoints != thisThing._points || newHash != thisThing._hash || newCreditUsed != thisThing._creditUsed || newPointsAdded != thisThing._pointsAdded )
            {
              appManager.setCurrentUser(user, ()=>
              {
                if( (newCreditUsed > thisThing._creditUsed || newPointsAdded > thisThing._pointsAdded) && !thisThing._isFirstPoll ) thisThing.announceTransaction(newCreditUsed - thisThing._creditUsed, newPointsAdded - thisThing._pointsAdded);
                thisThing._credit = newCredit;
                thisThing._points = newPoints;
                thisThing._hash = newHash;
                thisThing._creditUsed = newCreditUsed;
                thisThing._pointsAdded = newPointsAdded;
                thisThing._hash = newHash;
                thisThing.setTip();
                thisThing.forceUpdate();
              });
            }
          }
          thisThing._isFirstPoll = false;
          thisThing.queuePoll();
        }, ()=>
        {
          thisThing.queuePoll();
        })
      }
      else
      {
        thisThing.queuePoll();
      }
    }, appManager._isDemo ? 20000 : 5000);
  },

  _hash : null,
  _creditUsed : null,
  didUpdate : function()
  {
    var appManager = this.props.appManager;
    var addCreditFeature = this.props.appManager.getFeatureForName("AddCredit");
    var isLivePay = appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.PayMode] == 1;
    var shouldShowLoadCredit = !isLivePay && typeof addCreditFeature !== 'undefined' && addCreditFeature != null && !this.props.appActions._navigator.featureIsInStack(addCreditFeature);
    var shouldShowPaymentMethods = isLivePay;
    var shouldShowBalance = !isLivePay || (this.props.appManager.currentUser()[ModelConstants.Credits] > 0);
    var shouldShowTip = !isLivePay || (this.props.appManager.currentUser()[ModelConstants.Credits] > 0);

    this.setState({shouldShowBalance, shouldShowTip, shouldShowPaymentMethods, shouldShowLoadCredit});
  },

  _tipAmount : 0,
  _tipType : "P",
  setTip : function(amount, type)
  {
    if( typeof amount !== 'undefined' ) this._tipAmount = amount;
    if( typeof type !== 'undefined' ) this._tipType = type;

    var shouldUpdateButton = typeof amount !== 'undefined' && typeof type !== 'undefined';
    var appManager = this.props.appManager;

    if( typeof amount !== 'undefined' )
    {
      appManager.setVariable(PREVIOUS_TIP_AMOUNT, this._tipAmount);
      appManager._tipAmount = this._tipAmount;
    }
    else
    {
      amount = 0;
    }

    if( typeof type !== 'undefined' )
    {
      appManager.setVariable(PREVIOUS_TIP_TYPE, this._tipType);
      appManager._tipType = this._tipType;
    }
    else
    {
      type = "P";
    }

    var user = appManager.currentUser();
    var qrData = {};
    qrData["Type"] = "credit";
    qrData["AppID"] = appManager.getAppInfo()["appid"];
    qrData["U"] = user[ModelConstants.UserID];
    qrData["H"] = user[ModelConstants.Hash];
    qrData["T"] = typeof this._tipAmount === 'undefined' ? 0 : this._tipAmount;
    qrData["TT"] = typeof this._tipType === 'undefined' ? "P" : this._tipType;

    var qrDataBase64 = getBase64Data(qrData);

    if( this._ref_qrcode ) this._ref_qrcode.setData(qrDataBase64);

    if( shouldUpdateButton )
    {
      var newTipChoiceTitles = [];
      for( var i = 0; i < this.state.tipChoiceTitles.length-1; i++ )
      {
        newTipChoiceTitles.push(this.state.tipChoiceTitles[i]);
      }
      if( type == "P" ) newTipChoiceTitles.push(amount + "%");
      if( type == "D" ) newTipChoiceTitles.push(appManager.getLocalizationManager().localizedDollars(amount));
      this.setState({tipChoiceTitles:newTipChoiceTitles, hasSelectedTip:true});
    }
  },

  announceTransaction : function(deltaCredit, deltaPoints)
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();

    var message = "";
    if( deltaCredit > 0 && deltaPoints > 0 )
    {
      message = locManager.localizedStringForKeyAndParams("USER_WITHDREW_EARNED_STATEMENT",
        [locManager.localizedDollars(deltaCredit), locManager.localizedPoints(deltaPoints)],
        "You spent %0% and earned %1%.");
    }
    else if( deltaCredit > 0 )
    {
      message = locManager.localizedStringForKeyAndParams("USER_WITHDREW_STATEMENT",
        [locManager.localizedDollars(deltaCredit)]);
    }
    else if( deltaPoints > 0 )
    {
      message = locManager.localizedStringForKeyAndParams("USER_EARNED_STATEMENT",
        [locManager.localizedPoints(deltaPoints)]);
    }

    var pattern, patternLiteral, patternDescription;
    if (Platform.OS === 'android')
    {
      pattern = [0,2000];
    }
    else
    {
      pattern = [0];
    }
    Vibration.vibrate(pattern)

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var objBG = 'transparent';//appManager.getColorForKey("FeedCardBannerColor");
    var objFG = appManager.getColorForKey("ButtonPrimaryColor");//appManager.getColorForKey("FeedCardBannerIconColor");

    var MAX_OBJECTS = 10;
    var numObjects = Math.abs(deltaPoints);
    while(numObjects > MAX_OBJECTS) numObjects /= 2;

    var renderObject = ()=>{ return <View style={{width:40, height:40, borderRadius:20, backgroundColor:objBG, alignItems:'center', flexDirection:'row', justifyContent:'center'}} ><Icon name={"trophy"} size={40} color={objFG} style={{backgroundColor:'transparent'}} /></View>};
    var objects = [];
    for( var i = 0; i < numObjects; i++ )
    {
      var imod = i%4;
      var velX = (imod == 0 || imod == 1 ? -1 : 1 ) * (0.0005 + 0.0001 * Math.random());
      // var velY = (imod == 0 || imod == 3 ? -1 : 1 ) * (0.0005 + 0.0001 * Math.random());
      var velY = -0.001 + -0.002 * Math.random();
      var startTime = 300+(i+1)*100;
      objects.push({
        posX:.5, posY:.5, velX, velY, renderObject, startTime
      })
    }
    var thisThing = this;
    thisThing._doneButtonFadingView = null;
    setTimeout(()=>
    {
      if( thisThing._doneButtonFadingView ) thisThing._doneButtonFadingView.setFadedOut(false);
    }, 3000)
    // setTimeout(()=>
    // {
    //   if( thisThing.state.renderAlternative )
    //   {
    //     thisThing.setState({renderAlternative:false});
    //     setTimeout(()=>
    //     {
    //       thisThing.setTip();
    //     }, 200)
    //   }
    // }, 10000)
    this.setState({
      renderAlternative:true,
      renderAlternativeView:()=>
        <View style={{backgroundColor:generalColor, flexDirection:'column', alignItems:'center', justifyContent:'center', width:this.state.layout.width, height:this.state.layout.height}}>
        {
          false ?
            <PhysScene
              style={{position:'absolute', top:0, left:0, width:this.state.layout.width, height:this.state.layout.height}}
              objectInfos={objects}/>
          : null
        }
          <View style={{marginHorizontal:20, borderRadius:8, flexDirection:'column', alignItems:'center'}}>
            <View style={{width:100, height:100, flexDirection:'column', marginBottom:20}}>
              <CheckMarkView color={appManager.getColorForKey("FeedCardBannerColor")} style={{flex:1, alignSelf:'stretch'}} />
            </View>
            <ReUpText isTitle={true} appManager={appManager} style={{color:appManager.getColorForKey("FeedCardTitleColor"), backgroundColor:appManager.getColorForKey("FeedCardColor",.6), textAlign:'center'}}>
            {message}
            </ReUpText>
          </View>
          <FadingView ref={(a) => { thisThing._doneButtonFadingView = a }} animDuration={200} style={{height:50, marginHorizontal:20, marginTop:40, alignSelf:'stretch'}}>
            <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("DONE_BUTTON", "Done")} />
          </FadingView>
          <TouchableWithoutFeedback style={{position:'absolute', left:0, right:0, top:0, bottom:0}} onPress={()=>
            {
              thisThing.setState({renderAlternative:false});
              setTimeout(()=>
              {
                thisThing.setTip();
              }, 200)
            }} >
            <View style={{position:'absolute', left:0, right:0, top:0, bottom:0}} />
          </TouchableWithoutFeedback>
        </View>
    })
  },

  _previouslySelectedIndex : 0,
  didSelectTipIndex : function(index)
  {
    if( index < (this.state.tipChoiceValues.length) )
    {
      this._previouslySelectedIndex = index;
      this.setTip(this.state.tipChoiceValues[index], this.state.tipChoiceType == 0 ? "P" : "D");
      var newTipChoiceTitles = [];
      for( var i = 0; i < this.state.tipChoiceTitles.length-1; i++ )
      {
        newTipChoiceTitles.push(this.state.tipChoiceTitles[i]);
      }
      newTipChoiceTitles.push(this.props.appManager.getLocalizationManager().localizedStringForKey("OTHER_BUTTON"));
      this.setState({tipChoiceTitles:newTipChoiceTitles})
    }
    else
    {
      this.showTipPercentageChoice();
    }

  },

  _customPercent : 0,
  _tipPercentButton : null,
  showTipPercentageChoice : function()
  {
    this._customPercent = 0;
    var useCredit = this;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");
    var percentLabel = locMan.localizedStringForKey("PERCENTAGE_LABEL");
    var okButton = locMan.localizedStringForKey("SETTIP_LABEL") + " - " + (isNaN(parseFloat(useCredit._customPercent)) ? 0 : parseFloat(useCredit._customPercent)) + "%";//locMan.localizedStringForKey("OK_ALERT_BUTTON");
    var dollarSign = locMan.localizedDollarSymbol();

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <MKSegmentControl
          style={styles.tipTypeContainer}
          choiceTitles={["%",dollarSign]}
          didSelectIndex={function(index){if( index == 1 ){useCredit.showTipDollarChoice()}}}
          activeBackgroundColor={primaryButtonColor}
          activeShadowColor={primaryButtonBorderColor}
          activeTextColor={primaryButtonTitleColor}
          inactiveBackgroundColor={secondaryButtonColor}
          inactiveTextColor={secondaryButtonTitleColor}/>
        <View style={styles.tipValueContainer}>
          <ReUpField
            key="percent"
            ref={(a)=>
            {
              if( a != null )
              {
                a.focus()
                useCredit._tipField = a;
              }
            }}
            appManager={appManager}
            keyboardType={"numeric"}
            onChangeText={(text) =>
            {
              var tipError = isNaN(parseFloat(text)) || (parseFloat(text) < 0 );
              useCredit._tipField.setIsInError(tipError);
              useCredit._customPercent = tipError ? "0" : text;
              var newTitle = locMan.localizedStringForKey("SETTIP_LABEL") + " - " + parseFloat(useCredit._customPercent) + "%";
              useCredit._tipPercentButton.setTitle(newTitle);
            }}
            tintColor={bannerColor}
            highlightColor={bannerColor}
            textInputStyle={{color: generalTitleColor}}
            placeholder={percentLabel}
            style={[styles.textField]}/>
          <View style={{alignSelf:"flex-end", marginBottom:6}}><ReUpText appManager={appManager} style={styles.tipLabel}>
            %
          </ReUpText></View>
        </View>
        <ReUpButton key={"percentButton"} ref={(a) => { this._tipPercentButton = a }}
          style={[styles.button,{marginTop:20}]}
          appManager={appManager}
          text={okButton}
          onPress={() => {
            Keyboard.dismiss();
            setTimeout(()=>
            {
              useCredit._previouslySelectedIndex = useCredit.state.tipChoiceTitles.length-1;
              useCredit.setTip(useCredit._customPercent, "P");
              var newTipChoiceTitles = [];
              for( var i = 0; i < useCredit.state.tipChoiceTitles.length-1; i++ )
              {
                newTipChoiceTitles.push(useCredit.state.tipChoiceTitles[i]);
              }
              newTipChoiceTitles.push(useCredit._customPercent + "%");
              useCredit.setState({tipChoiceTitles:newTipChoiceTitles, hasSelectedTip:true});
            }, 200);
            useCredit.props.appActions.setCustomAlertShown(false);
          }}
          />
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
      // if( typeof useCredit._ref_segmentControl === 'undefined' ) return;
      // useCredit._ref_segmentControl.setSelectedIndex(useCredit._previouslySelectedIndex);
    });
  },



  _customDollar : 0,
  showTipDollarChoice : function()
  {
    this._customDollar = 0;
    var useCredit = this;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");
    var dollarLabel = locMan.localizedStringForKey("DOLLARS_LABEL");
    var okButton = locMan.localizedStringForKey("SETTIP_LABEL") + " - " + locMan.localizedDollars(useCredit._customDollar);//locMan.localizedStringForKey("OK_ALERT_BUTTON");
    var dollarSign = locMan.localizedDollarSymbol();
    var shouldPutDollarSignAtEnd = locMan.shouldUseComma();

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <MKSegmentControl
          style={styles.tipTypeContainer}
          choiceTitles={["%",dollarSign]}
          selectedIndex={1}
          didSelectIndex={function(index){if( index == 0 ){useCredit.showTipPercentageChoice()}}}
          activeBackgroundColor={primaryButtonColor}
          activeShadowColor={primaryButtonBorderColor}
          activeTextColor={primaryButtonTitleColor}
          inactiveBackgroundColor={secondaryButtonColor}
          inactiveTextColor={secondaryButtonTitleColor}/>
        <View style={[styles.tipValueContainer]}>
          {
            !shouldPutDollarSignAtEnd ?
              <View style={{alignSelf:"flex-end", marginBottom:6}}><ReUpText appManager={appManager} style={styles.tipLabel}>
                {dollarSign}
              </ReUpText></View>
            : null
          }
          <ReUpField
            key="dollar"
            ref={(a)=>
            {
              if( a != null )
              {
                a.focus()
                useCredit._dollarTipField = a;
              }
            }}
            appManager={appManager}
            keyboardType={"numeric"}
            onChangeText={(text) =>
            {
              var tipError = isNaN(parseFloat(text)) || (parseFloat(text) < 0 );
              useCredit._dollarTipField.setIsInError(tipError);
              useCredit._customDollar = tipError ? "0" : text;
              var newTitle = locMan.localizedStringForKey("SETTIP_LABEL") + " - " + locMan.localizedDollars(useCredit._customDollar);
              useCredit._dollarButton.setTitle(newTitle);
            }}
            tintColor={bannerColor}
            highlightColor={bannerColor}
            textInputStyle={{color: generalTitleColor}}
            placeholder={dollarLabel}
            style={[styles.textField]}/>

          {
            shouldPutDollarSignAtEnd ?
              <View style={{alignSelf:"flex-end", marginBottom:6}}><ReUpText appManager={appManager} style={styles.tipLabel}>
                {dollarSign}
              </ReUpText></View>
            : null
          }
          </View>
        <ReUpButton key={"dollarButton"} style={[styles.button,{marginTop:20}]}
          ref={(a) => { this._dollarButton = a }}
          appManager={appManager}
          text={okButton}
          onPress={() => {
            Keyboard.dismiss();
            setTimeout(()=>
            {
              useCredit._previouslySelectedIndex = useCredit.state.tipChoiceTitles.length-1;
              useCredit.setTip(useCredit._customDollar, "D");
              var newTipChoiceTitles = [];
              for( var i = 0; i < useCredit.state.tipChoiceTitles.length-1; i++ )
              {
                newTipChoiceTitles.push(useCredit.state.tipChoiceTitles[i]);
              }
              newTipChoiceTitles.push(locMan.localizedDollars(useCredit._customDollar));
              useCredit.setState({tipChoiceTitles:newTipChoiceTitles, hasSelectedTip:true});
            }, 200);
            useCredit.props.appActions.setCustomAlertShown(false);
          }}
          />
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
      // if( typeof useCredit._ref_segmentControl === 'undefined' ) return;
      // useCredit._ref_segmentControl.setSelectedIndex(useCredit._previouslySelectedIndex);
    });
  },

  render: function()
  {

    var addCredit = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var appActions = this.props.appActions;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");

    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
    var tipStatement = locManager.localizedStringForKey("TIP_PERCENTAGE_LABEL");
    var hasSelectedTip = this.state.hasSelectedTip;

    var addCreditFeature = appManager.getFeatureForName("AddCredit");

    var dimension = Math.min(this.state.layout.width-100, this.state.layout.height-164);

    var dollarsPerPoint = appManager.currentUser().DollarsPerPoint;
    var instructions = locManager.localizedStringForKeyAndParams("EARN_POINTS_DESCRIPTION", [locManager.localizedPoints(Math.round(1/dollarsPerPoint)), locManager.localizedDollars(1)]);
    var borderRadius = typeof this.props.extras !== 'undefined' && typeof this.props.extras.borderRadius !== 'undefined' ? this.props.extras.borderRadius : 0;

    return (
      <View style={[styles.container]}
        onLayout={(event)=>this.setState({containerLayout:event.nativeEvent.layout})}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height+Globals.ACTION_BAR_HEIGHT, overflow:'hidden', backgroundColor: generalColor, borderRadius}]} />

        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} bounces={true} responder={this} renderAlternative={this.state.renderAlternative} renderAlternativeView={this.state.renderAlternativeView}>
          <View style={{flexDirection:'row', alignItems:'stretch'}}>
            <View style={{height:this.state.layout.height}} />
            <View style={{flexDirection:'column'}}>
            <View style={{flex:1}}>
              <View style={[styles.instructionContainer, {backgroundColor: instructionColor, color:instructionTitleColor}]}>
                <View style={{alignSelf:'center', flex:1}}>
                  <ReUpText appManager={appManager} style={[styles.instructionText, {color:instructionTitleColor}]}>
                    {instructions}
                  </ReUpText>
                </View>
                <ReUpIconButton type={3}
                  appManager={appManager}
                  featureData={this.props.featureData}
                  appActions={this.props.appActions}
                  />
              </View>
              <ShadowView appManager={appManager} layout={this.state.layout} />
              <View style={{flex:1}} />
            </View>
            {
              this.state.shouldShowLoadCredit ?
                <ReUpButton isSecondary={true} style={{marginHorizontal:40, alignSelf:'stretch'}}
                  appManager={appManager}
                  text={addCreditFeature.data.title}
                  onPress={() => {
                    appActions.requestFeatureName("AddCredit");
                  }}
                  /> : null
            }
            <QRCodeView ref={(c) => { this._ref_qrcode = c; }} key="qrcode" data={""} dimension={dimension} style={styles.qrcode} spinnerView={<MKSpinner style={{alignSelf : 'center',backgroundColor : 'transparent'}} strokeColor={[generalTitleColor]} />} />
            {
              this.state.shouldShowBalance ?
                <View style={{alignSelf:'center', flex:-1}}>
                  <ReUpText appManager={appManager} style={{color:generalTitleColor}}>
                    {creditsLeftStatement}
                  </ReUpText>
                </View>
              : null
            }
            <View style={{flexDirection:'row', alignSelf:'stretch', marginTop:8, flex:-1}}>
            {
              this.state.shouldShowPaymentMethods ?
                <View style={{flex:1, padding:10, justifyContent:'center', alignSelf:'center'}}>
                  <PaymentMethodChooserView ref={(c) => { this._ref_paymentMethod = c; }}
                    style={{flex:1, marginTop:0}} useSmall={true}
                    appManager={appManager} appActions={this.props.appActions}
                    paymentInfo={appManager.getPaymentInfo()} />
                </View>
              : null
            }
            {
              this.state.tipEnabled && this.state.shouldShowPaymentMethods ?
                <View style={{flex:1, padding:10, paddingLeft:5, alignSelf:'stretch' }}>
                  <ReUpButton style={{flex:1, height:40}}
                    appManager={appManager}
                    text={!hasSelectedTip ? locManager.localizedStringForKey("SETTIP_LABEL") : (tipStatement + " " + this.state.tipChoiceTitles[this.state.tipChoiceTitles.length-1])}
                    onPress={() => {
                      if( this._tipType == "D" ) this.showTipDollarChoice();
                      else this.showTipPercentageChoice();
                    }}
                    />
                </View>
              : null
            }
            {
              this.state.tipEnabled && !this.state.shouldShowPaymentMethods ?
                <ReUpButton style={{marginHorizontal:40, flex:1, alignSelf:'stretch'}}
                  appManager={appManager}
                  text={!hasSelectedTip ? locManager.localizedStringForKey("SETTIP_LABEL") : (tipStatement + " " + this.state.tipChoiceTitles[this.state.tipChoiceTitles.length-1])}
                  onPress={() => {
                    if( this._tipType == "D" ) this.showTipDollarChoice();
                    else this.showTipPercentageChoice();
                  }}
                  />
                : null
            }
            </View>
            {
              true || ((this.state.tipChoiceTitles.length <= 0) || !(this.state.tipEnabled)) ?
              <View />
              :
              <ReUpText appManager={appManager} style={[styles.tipText, {color:generalTitleColor}]}>
                {tipStatement}
              </ReUpText>
            }
            <View style={{flex:1}} />
            </View>
          </View>
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    alignSelf:'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  tipText: {
    alignSelf: 'center'
  },
  backgroundView: {
    position: 'absolute',
  },
  qrcode: {
    padding: 10,
    alignItems:'center',
  },
  tipContainer: {
    height:50,
    flex:1,
    padding:10,
  },
  tipTypeContainer: {
    height:40,
    width:180,
    alignSelf:'center'
  },
  textField: {
    width:120,
    height:50,
    marginTop:10
  },
  button: {
    justifyContent:'center',
    flex:1,
  },
  tipValueContainer: {
    paddingTop:4,
    paddingLeft:20,
    paddingRight:20,
    alignItems:'center',
    justifyContent:'center',
    flexDirection:'row',
  },
  tipLabel: {
    paddingLeft:8,
    paddingRight:8,
    textAlign:'center',
    alignSelf:'flex-end',
  }
});

UseCredit.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();
  var locManager = appManager.getLocalizationManager();

  if( !isLoggedIn ) return [];
  else
  {
    var user = appManager.currentUser();
    var transactions = typeof data.Transactions === 'undefined' ? [] : data.Transactions;
    var biggestTimeStamp = 0;
    for( var i = 0; i < transactions.length; i++ )
    {
      var thisTrans = transactions[i];
      if( thisTrans.Credit > 0 )
      {
        var thisTime = appManager.getTime(thisTrans.Timestamp)
        if( thisTime > biggestTimeStamp )
        {
          biggestTimeStamp = thisTime;
        }
      }
    }
    var sortOrder = (new Date()).getTime() - biggestTimeStamp;
    sortOrder = sortOrder - 1000; // minus one so that we are on top of the transaction history card
    var didSelect = function() {appActions.requestFeatureName("UseCredit")};
    var iconName = featureData.data.icon.replace("fa-", "")
    var dollarsPerPoint = user.DollarsPerPoint;

    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 :  locManager.localizedStringForKeyAndParams("EARN_POINTS_DESCRIPTION", [locManager.localizedPoints(Math.round(1/dollarsPerPoint)), locManager.localizedDollars(1)]),
      icon : iconName,
      cardType : 0,
      sortOrder : sortOrder
    }];
  }
}

UseCredit.dataDependencies = ["Users", "Transactions"];

module.exports = UseCredit;
